import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAnalytics, logEvent } from "firebase/analytics";
import User from "./services/User";

const REQUIRED_KEYS = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const missingKeys = Object.entries(REQUIRED_KEYS)
  .filter(([, v]) => !v)
  .map(([k]) => k);

const isFirebaseConfigured = missingKeys.length === 0;

if (isFirebaseConfigured) {
  console.log(
    "[Firebase] ✅ Все env-ключи найдены:",
    Object.keys(REQUIRED_KEYS)
  );
} else {
  console.warn(
    "[Firebase] Отсутствуют обязательные env-ключи, Firebase отключён:",
    missingKeys
  );
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "saas-biny.firebaseapp.com",
  projectId: "saas-biny",
  storageBucket: "saas-biny.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let firebaseApp = null;
let messaging = null;
export let analytics = null;

if (isFirebaseConfigured) {
  try {
    firebaseApp = initializeApp(firebaseConfig);
    console.log("[Firebase] ✅ App успешно инициализирован.");

    try {
      analytics = getAnalytics(firebaseApp);
      console.log("[Firebase] ✅ Analytics подключён.");
    } catch (e) {
      console.warn("[Firebase] Analytics не инициализирован:", e);
    }

    try {
      if (typeof Notification !== "undefined") {
        messaging = getMessaging(firebaseApp);
        console.log("[Firebase] ✅ Messaging подключён.");
      } else {
        console.warn("[Firebase] Messaging пропущен — Notification API недоступен.");
      }
    } catch (e) {
      console.warn("[Firebase] Messaging не инициализирован:", e);
    }
  } catch (e) {
    console.error("[Firebase] Ошибка инициализации приложения:", e);
  }
}

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export const requestPermissionAndGetToken = async (userId) => {
  if (!isFirebaseConfigured || !messaging) {
    console.warn("[Firebase] Messaging недоступен — ключи не настроены.");
    return;
  }

  if (
    typeof Notification === "undefined" ||
    typeof Notification.requestPermission !== "function"
  ) {
    console.warn("Уведомления не поддерживаются на этом устройстве/браузере.");
    return;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const currentToken = await getToken(messaging, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration:
          "serviceWorker" in navigator
            ? await navigator.serviceWorker.ready
            : undefined,
      });

      if (currentToken) {
        console.log("FCM Token:", currentToken);
        await User.saveFcmToken(userId, currentToken);
      } else {
        console.warn("Не удалось получить токен.");
      }
    } else {
      console.warn("Разрешение на уведомления не получено.");
    }
  } catch (error) {
    console.error("Ошибка при получении уведомлений:", error);
  }
};

export const onForegroundMessage = (callback) => {
  if (!isFirebaseConfigured || !messaging || typeof onMessage !== "function") {
    console.warn("[Firebase] Foreground messaging недоступен.");
    return;
  }

  onMessage(messaging, (payload) => {
    console.log("[Foreground] Push получен:", payload);

    if (analytics) {
      logEvent(analytics, "notification_received");
    }

    if (callback) callback(payload);
  });
};
